const stats = [
  { label: "今日更新", value: "128", unit: "组" },
  { label: "实锤截图", value: "3.6", unit: "万张" },
  { label: "高清原图", value: "100%", unit: "保留" },
];

export default function Hero() {
  return (
    <section id="top" className="relative w-full">
      <div className="relative h-[560px] w-full overflow-hidden md:h-[720px]">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20editorial%20magazine%20hero%20background%20with%20layered%20warm%20cream%20paper%20sheets%20and%20deep%20crimson%20red%20torn%20strips%2C%20soft%20directional%20studio%20light%2C%20fine%20grain%20and%20shadow%20depth%2C%20minimal%20art%20direction%2C%20muted%20warm%20palette%2C%20wide%20cinematic%20composition%2C%20high%20detail&width=1800&height=1000&seq=hl-hero-bg-01&orientation=landscape"
          alt="黑料图片实锤截图专题封面"
          title="黑料图片 · 实锤截图封面"
          className="h-full w-full object-cover object-top animate-slow-zoom"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/60" />

        <div className="absolute inset-0">
          <div className="mx-auto flex h-full w-full max-w-6xl flex-col justify-end px-4 pb-28 md:px-8 md:pb-36">
            <div className="animate-fade-up">
              <div className="mb-4 flex flex-wrap items-center gap-3 text-[11px] font-medium uppercase tracking-[0.25em] text-background-100">
                <span>第 218 期</span>
                <span className="h-3 w-px bg-background-300/60" />
                <span>实锤现场 · 聊天记录 · 证据截图</span>
              </div>
              <h1 className="max-w-3xl font-heading text-3xl font-black leading-tight text-background-50 md:text-5xl lg:text-6xl">
                一图看懂
                <br className="hidden md:block" />
                每一处实锤细节
              </h1>
              <p className="mt-5 max-w-2xl text-sm leading-relaxed text-background-100 md:text-base">
                聚焦黑料图片，实锤截图与聊天记录一手直达。高清原图、证据截图持续更新，帮你快速锁定关键信息，吃瓜不迷路。
              </p>

              <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
                <a
                  href="#gallery"
                  className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
                >
                  <i className="ri-image-2-line text-lg" />
                  查看今日实锤
                </a>
                <a
                  href="#download"
                  className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300/70 bg-background-50/10 px-6 py-3.5 text-sm font-semibold text-background-50 backdrop-blur transition-colors hover:bg-background-50/20"
                >
                  <i className="ri-download-2-line text-lg" />
                  下载客户端
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="absolute inset-x-0 bottom-0 border-t border-background-50/15 bg-black/25 backdrop-blur-sm">
          <div className="mx-auto grid max-w-6xl grid-cols-3 divide-x divide-background-50/15 px-4 md:px-8">
            {stats.map((s) => (
              <div key={s.label} className="flex flex-col items-center gap-1 py-4 md:py-5">
                <span className="text-[11px] tracking-widest text-background-200 md:text-xs">
                  {s.label}
                </span>
                <span className="font-heading text-lg font-bold text-background-50 md:text-2xl">
                  {s.value}
                  <span className="ml-1 text-xs font-normal text-background-200">{s.unit}</span>
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}